interface IKBarState {
  searchInputFocused: boolean;
  openSelectAppModal: boolean;
  shouldUpdateApps: boolean;
}

export const initialState: IKBarState = {
  searchInputFocused: false,
  openSelectAppModal: false,
  shouldUpdateApps: false,
};
